import React from "react";
import { Form } from "react-bootstrap";

const ProgramSelect = ({ selectedProgram, activePrograms, handleProgramChange, disabled }) => {
    return (
        <Form.Group controlId="formProgramDropdown" className="form-group new-form">
            <h1 className="header-class_mobil">Swasth Bharat</h1>
            <Form.Label className="lablecl">

                {selectedProgram
                    ? `Login With Program - ${selectedProgram}`
                    : "Login With Program"}
            </Form.Label>

            <Form.Select
                aria-label="Select a program"
                className="form-control new_padding"
                value={selectedProgram}
                onChange={handleProgramChange}
                disabled={disabled}
            >
                <option value="">Select Program</option>

                {activePrograms?.length > 0 &&
                    activePrograms.map((prog, index) => (
                        <option key={index} value={prog.program_name}>
                            {prog.program_name}
                        </option>
                    ))}
            </Form.Select>
        </Form.Group>
    );
};

export default ProgramSelect;
